// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__p8FBQ","social":"socials__social__H5Cvu","rtlSocial":"socials__rtlSocial__anBle","icon":"socials__icon__zgZ7n","navOpen":"socials__navOpen__LZMxA"};